export const ROUTES = {
  PAYMENT_BASE: "/payment",
  PAYMENT_LIST: "/payment/list",
  PAYMENT_DETAILS: "/payment/details",
  SALES_REVENUE: "/sales-revenue"
};
